import { useEffect, useState } from 'react';

export const useYoutubeVideoData = (videoId) => {
  const [videoData, setVideoData] = useState();

  useEffect(() => {
    const getVideoData = async () => {
      try {
        const res = await fetch(
          `https://youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`,
        );
        const data = await res.json();

        setVideoData(data);
      } catch (err) {
        throw new Error(err);
      }
    };

    getVideoData();
  }, [videoId]);

  return { videoData };
};
